import { api } from "@/api/api";

export const Notice = {
    state: {
        noticeList: [],
    },
    getters: {
        getNoticeList(state) {
            return state.noticeList;
        },
    },
    mutations: {
        setNoticeList(state, payload) {
            state.noticeList = payload;
        },
    },
    actions: {
        async getNoticeList({ commit }) {
            await api.notice
                .getNoticeList()
                .then((res) => {
                    commit("setNoticeList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async addNotice({ dispatch }, args) {
            await api.notice
                .addNotice(args)
                .then(() => {
                    dispatch("getNoticeList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async updateNotice({ dispatch }, args) {
            await api.notice
                .updateNotice(args)
                .then(() => {
                    dispatch("getNoticeList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteNotice({ dispatch }, args) {
            await api.notice
                .deleteNotice(args)
                .then(() => {
                    dispatch("getNoticeList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },
    },
};
